import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { kbaseLinks } from '../configs'
import { HelpSection } from '../enums/HelpSection'

interface IGetLinkBySectionAndProgramType {
  section: HelpSection
  programType: ProgramTypes
}

export const getLinkBySectionAndProgramType = ({
  section,
  programType,
}: IGetLinkBySectionAndProgramType): string => {
  return kbaseLinks[programType]?.[section]
}
